<template>
    <bottom-sheet
            title="預計多久"
            description="選擇大概的時間即可"
            @onCancel="onCancel"
            @onConfirm="onConfirm"
            @onClose="onClose">
        <smooth-picker class="picker" ref="picker" :data="data" :change="onChange"/>
    </bottom-sheet>
</template>

<script>
    import BottomSheet from '../BottomSheet';

    export default {
        name: 'SetWaitTime',
        components: {
            'bottom-sheet': BottomSheet,
        },
        props: {
            hours: {
                default: 2,
                required: true,
            }
        },
        data() {
            return {
                timeIndex: 0,
            };
        },
        computed: {
            data() {
                return [
                    {
                        currentIndex: this.timeIndex,
                        flex: 2,
                        list: [{days: 2, value: '2小時'},{days: 3, value: '3小時'},{days: 4, value: '4小時'},{days: 5, value: '5小時'},{days: 6, value: '6小時'},{days: 7, value: '7小時'},{days: 8, value: '8小時'},{days: 9, value: '9小時'},{days: 10, value: '10小時'},{days: 11, value: '11小時'},{days: 12, value: '12小時'}],
                        textAlign: 'center',
                    }
                ]
            },
        },
        methods: {
            init() {
                this.timeIndex = parseInt(this.hours) - 2;
            },
            onCancel() {
                this.$emit('onDone',  this.hours);
            },
            onConfirm() {
                let ciList = this.$refs.picker.getCurrentIndexList();
                this.timeIndex = ciList[0] + 2;
                let time = this.timeIndex;
                this.$emit('onDone', time);
            },
            onClose() {
                this.$emit('onDone',  this.hours);
            },
            onChange() {
                let ciList = this.$refs.picker.getCurrentIndexList();
                this.timeIndex = ciList[0] + 2;
            },
        },
        created() {
            this.init();
        },
        watch: {
            hours() {
                this.init();
            }
        }
    };
</script>

<style lang="scss">
    .picker {
        .smooth-middle {
            height: 2.5em !important;
        }
    }
</style>
